<template>
    <div id="app">
		<notifications group="foo" position="bottom right" />
        <router-view/>
    </div>
</template>
<script>
    import '../static/website/js/jquery.min.js'
    import '../static/website/js/popper.min.js'
    import '../static/website/js/bootstrap.min.js'
    import * as types from './types'
    import { mapActions } from 'vuex'
	export default {
		name: 'app',
        data(){
            return{
                walletSessionTimeOut: false
            }
        },
		created() {
            console.log('upload new1')
            
        },
    }
</script>

<style>
    @import '../static/website/css/bootstrap.min.css';
    @import '../static/website/css/style.css';
    @import '../static/website/css/responsive.css'; 
</style>


// WEBPACK FOOTER //
// src/App.vue